import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useListEarnedBadgesForMerchantQuery } from 'lib/shop/api';
import Image from 'next/image';
import { useRouter } from 'next/router';
import React from 'react';

export default function MerchantBadges() {
  const router = useRouter();
  const { merchantId } = router.query;

  const { data: earnedBadges, isLoading: isBadgesLoading } =
    useListEarnedBadgesForMerchantQuery(
      router.isReady && merchantId
        ? {
            merchantIdOrSlug: merchantId as string,
          }
        : skipToken,
    );

  return (
    <div>
      {!isBadgesLoading && earnedBadges && earnedBadges.length > 0 && (
        <>
          <div className="pb-4">
            <div className="flex gap-4.5">
              {earnedBadges?.map(badge => (
                <div
                  key={badge.badge.id}
                  className="flex w-20 flex-col items-center"
                >
                  <div className="relative mb-2.5 h-12 w-12">
                    <Image
                      alt={`${badge.badge.title}`}
                      src={badge.badge.icon.url ?? ''}
                      width={48}
                      height={48}
                    />
                  </div>
                  <div className="h8 w-full text-center">
                    {badge.badge.title}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="py-5">
            <div className="h-px w-full border-t border-gray-300"></div>
          </div>
        </>
      )}
    </div>
  );
}
